import { FormGroup } from "@angular/forms";
import { ISavedShipToAddressPostDtoModel } from "lib-core-shared";
import { ISavedAddressDtoModel } from "lib-core-shared";
import { ISavedAddressPostDtoModel } from "lib-core-shared";
import { ISavedAddressDetailsModel, ISavedAddressModel } from "lib-core-shared";
import { ISavedAddressDetailsDtoModel } from "lib-core-shared";

export class ResolveCustomerAddressMapping {
    public linkedAddresses!: ISavedAddressModel[];
    toApplicationPostModel(group: FormGroup, customerId?: string): ISavedAddressPostDtoModel {
        return {
            customerId: customerId,
            address: this.toChildApplicationModel(group)
        } as ISavedAddressPostDtoModel
    }
    toChildApplicationModel(group: FormGroup): ISavedAddressDetailsDtoModel | undefined {

        return group ? {
            name: group.controls?.name?.value ? group.controls?.name?.value : undefined,
            addressLine1: group.controls?.addressLine1?.value ? group.controls?.addressLine1?.value : undefined,
            addressLine2: group.controls?.addressLine2?.value ? group.controls?.addressLine2?.value : undefined,
            townCity: group.controls?.townCity?.value ? group.controls?.townCity?.value : undefined,
            countyState: group.controls?.countyState?.value ? group.controls?.countyState?.value : undefined,
            postalCode: group.controls?.postalCode?.value ? group.controls?.postalCode?.value : undefined,
            countryName: group.controls?.country?.value?.name ? group.controls?.country?.value?.name : undefined,
            countryCode: group.controls?.country?.value?.code ? group.controls?.country?.value?.code : undefined,
            isDefault: group?.controls?.isDefault?.value,
            isResidentialAddress: group?.controls?.isResidentialAddress?.value,
            isBillTo: group?.controls?.isBillTo?.value,
            isBillToDefault: group?.controls?.isBillToDefault?.value,
            isShipTo: group?.controls?.isShipTo?.value,
            isShipToDefault: group?.controls?.isShipToDefault?.value,
            isVerified: group?.controls?.isVerified?.value,
            contactNumber: group.controls?.contactNumber?.value ? group.controls?.contactNumber?.value : undefined,
        } as ISavedAddressDetailsDtoModel : undefined;
    }

    toApplicationPutModel(group: FormGroup, addressId?: string): ISavedAddressDtoModel {
        return {
            id: group.controls.id.value,
            details: this.toChildApplicationModel(group.controls.details as FormGroup)
        } as ISavedAddressDtoModel
    }

    toApplicationPutModelFromDefaultAddress(group: FormGroup, addressId?: string): ISavedAddressDtoModel {
        return {
            id: group.controls.defaultAddress.value.id,
            details: group.controls.defaultAddress.value.details
        } as ISavedAddressDtoModel
    }


}

